import { billOfMaterialsIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";
import {
  BillOfMaterialsProductInput,
  BillOfMaterialsStatus,
} from "./bill-of-materials-types";

const UpdateBillOfMaterialsInput_ = z.object({
  billOfMaterialsId: billOfMaterialsIdFormat.schema,
  name: z.string().optional(),
  tags: z.array(z.string()).optional(),
  status: BillOfMaterialsStatus.optional(),
  products: z.array(BillOfMaterialsProductInput).optional(),
});
export const UpdateBillOfMaterialsInput: z.ZodType<UpdateBillOfMaterialsInput> =
  UpdateBillOfMaterialsInput_;
export interface UpdateBillOfMaterialsInput
  extends z.infer<typeof UpdateBillOfMaterialsInput_> {}

export const updateBillOfMaterials = {
  name: "updateBillOfMaterials" as const,
  input: UpdateBillOfMaterialsInput,
  output: z.object({ success: z.boolean() }),
};
